/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CfStackResource } from './cfStackResource';


export interface CloudFormationStack { 
    /**
     * Cloud Formation Stack name
     */
    name: string;
    /**
     * Cloud Formation Stack status
     */
    status: string;
    resources: Array<CfStackResource>;
}

